<template>
	<div id="app">
		<router-view v-if="gameAvailable" />
		<ExcScr v-if="!gameAvailable" />
	</div>
</template>

<script>
import ExcScr from "@/views/ExcScr.vue";

export default {
	components: {
		ExcScr
	},
	data() {
		return {
			gameAvailable: false
		};
	},
	mounted() {
		try {
			const h = window.innerHeight * window.devicePixelRatio;
			const w = window.innerWidth * window.devicePixelRatio;
			if ((w >= 1024 && h >= 600) || (w >= 600 && h >= 1024)) {
				this.gameAvailable = true;
			}
		} catch {}
	}
};
</script>

<style lang="scss">
@import "scss/bootstrap";
</style>
